import PropTypes from 'prop-types'
import { Edit } from '@styled-icons/boxicons-solid'
import { formatEmptyValue, humanizeBool } from '../../../utils/common'

const SalesCodesRow = (props) => {
  return (
    <div className="bg-white w-full px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex items-center w-full">
        <div className="flex w-2/12  pl-10 items-center">{props.name}</div>
        <div className="flex w-4/12 pl-6 items-center table_text">
          {formatEmptyValue(props.description)}
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text">
          {formatEmptyValue(props.group?.name)}
        </div>
        <div className="w-4/12 pl-6">
          {formatEmptyValue(props.group?.description)}
        </div>
        <div className="w-2/12 pl-6">{humanizeBool(props.default)}</div>

        <div className="flex items-center w-2/12 pl-6 justify-end">
          <span
            onClick={() => {
              props.onEdit()
            }}
            className="cursor-pointer p-2"
          >
            <Edit size="2rem" color="#0189E9" />
          </span>
        </div>
      </div>
    </div>
  )
}

SalesCodesRow.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  group: PropTypes.object.isRequired,
  default: PropTypes.bool,
}

export default SalesCodesRow
